import { Options } from 'ky';
import config from 'config';
import { useAuthenticatedApiClient } from 'utils/apiClient/base';
import { ActionType } from 'Settings/types';
import {
  AccountingSetupInfo,
  IncomingAccountInfo as CashBookAccountInfo,
  IncomingAccountInfo,
  IncomingAccountInfoPayload,
  ProductGroupsInfo,
  ProductGroupsInfoPayload,
  CashBookAccountInfoPayload,
} from './types';

const accountingClientOpts: Options = {
  prefixUrl: `${config.CORE_URL}/api/accounting`,
};

const headers = {
  'Content-type': 'application/json',
};

export default function useAccountingApi() {
  const authenticatedApiClient = useAuthenticatedApiClient();
  const accountingApiClient =
    authenticatedApiClient.extend(accountingClientOpts);
  return {
    getAccountingSetup: async () =>
      accountingApiClient.get(`setup/`).json<AccountingSetupInfo>(),
    submitAccountingSetup: async ({
      actionType,
      payload,
    }: {
      actionType: ActionType;
      payload: AccountingSetupInfo;
    }) => {
      if (
        actionType === 'Post' &&
        localStorage.getItem('accounting-setup') === 'false'
      ) {
        return accountingApiClient
          .post('setup/', {
            headers,
            body: JSON.stringify(payload),
          })
          .json<AccountingSetupInfo>();
      }
      return accountingApiClient
        .put('setup/', {
          headers,
          body: JSON.stringify(payload),
        })
        .json<AccountingSetupInfo>();
    },

    getCategoriesInfo: async () =>
      accountingApiClient.get(`categories/`).json<Array<ProductGroupsInfo>>(),
    postCategoriesInfo: async (payload: Array<ProductGroupsInfoPayload>) =>
      accountingApiClient
        .post('categories/', {
          headers,
          body: JSON.stringify(payload),
        })
        .json<Array<ProductGroupsInfo>>(),
    getIncomingInfo: async () =>
      accountingApiClient.get(`incoming/`).json<Array<IncomingAccountInfo>>(),
    postIncomingInfo: async (payload: Array<IncomingAccountInfoPayload>) =>
      accountingApiClient
        .post('incoming/', {
          headers,
          body: JSON.stringify(payload),
        })
        .json<Array<IncomingAccountInfo>>(),
    getCashBookInfo: async () => {
      const cashBookData = await accountingApiClient
        .get(`cashbook/`)
        .json<Array<CashBookAccountInfo>>();
      const normalizedCashBookData = cashBookData
        .filter((item) => item.transaction_category === 'payment')
        .map((item) => ({
          ...item,
          tax_rate: item.tax_rate === null ? '0.000' : item.tax_rate,
        }));
      return normalizedCashBookData;
    },
    postCashBookInfo: async (payload: Array<CashBookAccountInfoPayload>) =>
      accountingApiClient
        .post('cashbook/', {
          headers,
          body: JSON.stringify(payload),
        })
        .json<Array<CashBookAccountInfo>>(),
  };
}
